import Bold from './bold';

class Italic extends Bold {
  static blotName = 'italic';
  static tagName = ['EM', 'I'];
}

export default Italic;
